import { useEffect, useRef, useState, useMemo } from "react";
import LeadGateModal from "../Modals/LeadGateModal.jsx";
import SuccessModal from "../Modals/SuccessModal.jsx";
import ConfirmSendResultsModal from "../Modals/ConfirmSendResultsModal.jsx";
import UpdateEmailModal from "../Modals/UpdateEmailModal.jsx";

import { detectToolsOrigin } from "../../../utils/helper.js";
import axios from "axios";
import "../calculator.scss";

// ===== YEAR CONFIG: DISCLAIMER (Bonus style) =====
const YEAR_CONFIG = {
  2025: {
    disclaimer:
      "* This calculator provides estimates for capital gains taxes only. Actual tax liability may vary based on your full tax situation, deductions, credits, state taxes, and other factors. Consult a tax professional for personalized advice.",
  },
  2026: {
    disclaimer:
      "* This calculator provides estimates for capital gains taxes only. Actual tax liability may vary based on your full tax situation, deductions, credits, state taxes, and other factors. Consult a tax professional for personalized advice.",
  },
};

// ===== YEAR CONFIG =====
const CAPITAL_GAINS_CONFIG = {
  2025: {
    incomeLabel: "Estimated 2025 Taxable Income",
    shortTermBrackets: {
      single: [
        { min: 0, max: 11925, rate: 0.1 },
        { min: 11926, max: 48475, rate: 0.12 },
        { min: 48476, max: 103350, rate: 0.22 },
        { min: 103351, max: 197300, rate: 0.24 },
        { min: 197301, max: 250525, rate: 0.32 },
        { min: 250526, max: 626350, rate: 0.35 },
        { min: 626351, max: Infinity, rate: 0.37 },
      ],
      marriedJoint: [
        { min: 0, max: 23850, rate: 0.1 },
        { min: 23851, max: 96950, rate: 0.12 },
        { min: 96951, max: 206700, rate: 0.22 },
        { min: 206701, max: 394600, rate: 0.24 },
        { min: 394601, max: 501050, rate: 0.32 },
        { min: 501051, max: 1252700, rate: 0.35 },
        { min: 1252701, max: Infinity, rate: 0.37 },
      ],
      marriedSeparate: [
        { min: 0, max: 11925, rate: 0.1 },
        { min: 11926, max: 48475, rate: 0.12 },
        { min: 48476, max: 103350, rate: 0.22 },
        { min: 103351, max: 197300, rate: 0.24 },
        { min: 197301, max: 250525, rate: 0.32 },
        { min: 250526, max: 626350, rate: 0.35 },
        { min: 626351, max: Infinity, rate: 0.37 },
      ],
      headOfHousehold: [
        { min: 0, max: 17000, rate: 0.1 },
        { min: 17001, max: 64850, rate: 0.12 },
        { min: 64851, max: 103350, rate: 0.22 },
        { min: 103351, max: 197300, rate: 0.24 },
        { min: 197301, max: 250500, rate: 0.32 },
        { min: 250501, max: 626350, rate: 0.35 },
        { min: 626351, max: Infinity, rate: 0.37 },
      ],
    },
    longTermBrackets: {
      single: [
        { min: 0, max: 48350, rate: 0.0 },
        { min: 48351, max: 533400, rate: 0.15 },
        { min: 533401, max: Infinity, rate: 0.2 },
      ],
      marriedJoint: [
        { min: 0, max: 96700, rate: 0.0 },
        { min: 96701, max: 600050, rate: 0.15 },
        { min: 600051, max: Infinity, rate: 0.2 },
      ],
      marriedSeparate: [
        { min: 0, max: 48350, rate: 0.0 },
        { min: 48351, max: 300000, rate: 0.15 },
        { min: 300001, max: Infinity, rate: 0.2 },
      ],
      headOfHousehold: [
        { min: 0, max: 64750, rate: 0.0 },
        { min: 64751, max: 566700, rate: 0.15 },
        { min: 566701, max: Infinity, rate: 0.2 },
      ],
    },
  },

  2026: {
    incomeLabel: "Estimated 2026 Taxable Income",
    shortTermBrackets: {
      single: [
        { min: 0, max: 12400, rate: 0.1 },
        { min: 12401, max: 50400, rate: 0.12 },
        { min: 50401, max: 105700, rate: 0.22 },
        { min: 105701, max: 201775, rate: 0.24 },
        { min: 201776, max: 256225, rate: 0.32 },
        { min: 256226, max: 640600, rate: 0.35 },
        { min: 640601, max: Infinity, rate: 0.37 },
      ],
      marriedJoint: [
        { min: 0, max: 24800, rate: 0.1 },
        { min: 24801, max: 100800, rate: 0.12 },
        { min: 100801, max: 211400, rate: 0.22 },
        { min: 211401, max: 403550, rate: 0.24 },
        { min: 403551, max: 512450, rate: 0.32 },
        { min: 512451, max: 768700, rate: 0.35 },
        { min: 768701, max: Infinity, rate: 0.37 },
      ],
      marriedSeparate: [
        { min: 0, max: 12400, rate: 0.1 },
        { min: 12401, max: 50400, rate: 0.12 },
        { min: 50401, max: 105700, rate: 0.22 },
        { min: 105701, max: 201775, rate: 0.24 },
        { min: 201776, max: 256225, rate: 0.32 },
        { min: 256226, max: 384350, rate: 0.35 },
        { min: 384351, max: Infinity, rate: 0.37 },
      ],
      headOfHousehold: [
        { min: 0, max: 17700, rate: 0.1 },
        { min: 17701, max: 67450, rate: 0.12 },
        { min: 67451, max: 105700, rate: 0.22 },
        { min: 105701, max: 201775, rate: 0.24 },
        { min: 201776, max: 256225, rate: 0.32 },
        { min: 256226, max: 640600, rate: 0.35 },
        { min: 640601, max: Infinity, rate: 0.37 },
      ],
    },
    longTermBrackets: {
      single: [
        { min: 0, max: 49450, rate: 0.0 },
        { min: 49451, max: 545500, rate: 0.15 },
        { min: 545501, max: Infinity, rate: 0.2 },
      ],
      marriedJoint: [
        { min: 0, max: 98900, rate: 0.0 },
        { min: 98901, max: 613700, rate: 0.15 },
        { min: 613701, max: Infinity, rate: 0.2 },
      ],
      marriedSeparate: [
        { min: 0, max: 49450, rate: 0.0 },
        { min: 49451, max: 306850, rate: 0.15 },
        { min: 306851, max: Infinity, rate: 0.2 },
      ],
      headOfHousehold: [
        { min: 0, max: 66200, rate: 0.0 },
        { min: 66201, max: 579600, rate: 0.15 },
        { min: 579601, max: Infinity, rate: 0.2 },
      ],
    },
  },
};

// ===== HELPERS (shared) =====
const taxAt = (amount, brackets) => {
  let total = 0;
  for (const b of brackets) {
    if (amount > b.min) {
      const taxable = Math.min(amount, b.max) - b.min;
      if (taxable > 0) total += taxable * b.rate;
    }
  }
  return total;
};

const incrementalTax = (base, delta, brackets) => {
  if (!isFinite(base) || !isFinite(delta) || delta <= 0) return 0;
  return taxAt(base + delta, brackets) - taxAt(base, brackets);
};

const fmtMoney = (n) =>
  (Number(n) || 0).toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  });

// ---------- PROXY (same pattern as Federal) ----------
const PROXY_URL =
  window.__UK_PROXY_URL__ ||
  `${detectToolsOrigin()}/.netlify/functions/api-proxy`;

// ===== MAIN COMPONENT =====
function CapitalGainsTaxCalculator({
  year = 2025,
  calculatorName = "Capital Gains Tax Calculator",
  endpoint = PROXY_URL,
}) {
  const config = CAPITAL_GAINS_CONFIG[year] || CAPITAL_GAINS_CONFIG[2025];
  const yearCfg = YEAR_CONFIG[year] || YEAR_CONFIG[2025];

  // ✅ IMPORTANT: filingStatus MUST match keys in config: single/marriedJoint/marriedSeparate/headOfHousehold
  const [filingStatus, setFilingStatus] = useState("single");
  const [taxableIncome, setTaxableIncome] = useState("");
  const [holdingPeriod, setHoldingPeriod] = useState("short-term");
  const [costBasis, setCostBasis] = useState("");
  const [saleProceeds, setSaleProceeds] = useState("");
  const [results, setResults] = useState(null);

  const pageUrl = typeof window !== "undefined" ? window.location.href : "";
  const resultsRef = useRef(null);

  const params = useMemo(() => new URLSearchParams(window.location.search), []);
  const qa = useMemo(() => params.has("qa_mode"), [params]);

  // ✅ keep latest computed payload for emailing (includes pdf_notes like Bonus)
  const latestPayloadRef = useRef({
    inputs_json: null,
    results_json: null,
    pdf_notes: null,
  });

  // ---------- Gating storage helpers (24h, shared across calculators) ----------
  const UNK_GATE_KEY = "unk_calc_unlock_v1";
  const UNK_GATE_TTL_MS = 24 * 60 * 60 * 1000;

  const readUnlock = () => {
    try {
      const raw = localStorage.getItem(UNK_GATE_KEY);
      if (!raw) return { unlocked: false, email: "" };
      const parsed = JSON.parse(raw);
      const expiresAt = Number(parsed?.expiresAt || 0);
      const email = String(parsed?.email || "");
      if (!expiresAt || Date.now() > expiresAt) {
        localStorage.removeItem(UNK_GATE_KEY);
        return { unlocked: false, email: "" };
      }
      return { unlocked: true, email };
    } catch {
      return { unlocked: false, email: "" };
    }
  };

  const writeUnlock = ({ email }) => {
    const payload = {
      expiresAt: Date.now() + UNK_GATE_TTL_MS,
      email: String(email || ""),
    };
    localStorage.setItem(UNK_GATE_KEY, JSON.stringify(payload));
  };

  // --- gating state ---
  const [unlocked, setUnlocked] = useState(false);
  const [storedEmail, setStoredEmail] = useState("");

  // modals
  const [showLeadModal, setShowLeadModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showUpdateEmailModal, setShowUpdateEmailModal] = useState(false);

  const [sendingResults, setSendingResults] = useState(false);

  useEffect(() => {
    const gate = readUnlock();
    setUnlocked(gate.unlocked);
    setStoredEmail(gate.email || "");
  }, []);

  const scrollToResults = () => {
    const el = resultsRef.current;
    if (el && typeof el.scrollIntoView === "function") {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const openGateFlow = () => {
    if (unlocked) {
      setShowConfirmModal(true);
      return;
    }
    setShowLeadModal(true);
  };

  const handleLeadSuccess = ({ email }) => {
    writeUnlock({ email });

    setUnlocked(true);
    setStoredEmail(email || "");
    setShowLeadModal(false);
    setShowSuccessModal(true);
  };

  const handleSuccessViewResults = () => {
    setShowSuccessModal(false);
    scrollToResults();
  };

  const computeResults = () => {
    const income = Number(taxableIncome);
    const cost = Number(costBasis);
    const proceeds = Number(saleProceeds);

    if (!isFinite(income) || !isFinite(cost) || !isFinite(proceeds)) return null;

    const gain = proceeds - cost;

    const inputs_json = {
      filingStatus,
      taxableIncome,
      holdingPeriod,
      costBasis,
      saleProceeds,
      calculator_year: String(year),
    };

    const pdf_notes = {
      disclaimer: yearCfg.disclaimer,
      methods: {
        short_term:
          "Short-term capital gains (held 1 year or less) are typically taxed at ordinary income tax rates.",
        long_term:
          "Long-term capital gains (held more than 1 year) may qualify for preferential capital gains tax rates.",
      },
      footer: {
        cta_title: "Want a personalized tax strategy? Speak with an Uncle Kam expert.",
        cta_subtitle: "Visit us at unclekam.com",
      },
    };

    if (gain <= 0) {
      const results_json = {
        capitalGain: gain,
        taxOwned: 0,
        effectiveRate: 0,
        marginalRate: 0,
        netProceeds: proceeds,
      };

      return { inputs_json, results_json, pdf_notes };
    }

    let tax = 0;
    let effectiveRate = 0;
    let marginalRate = 0;

    if (holdingPeriod === "short-term") {
      const brackets = config.shortTermBrackets[filingStatus];
      tax = incrementalTax(income, gain, brackets);
      effectiveRate = (tax / gain) * 100;

      const m = brackets.find(
        (b) => income + gain > b.min && income + gain <= b.max
      );
      marginalRate =
        ((m ? m.rate : brackets[brackets.length - 1].rate) || 0) * 100;
    } else {
      const brackets = config.longTermBrackets[filingStatus];
      tax = incrementalTax(income, gain, brackets);
      effectiveRate = (tax / gain) * 100;

      const m = brackets.find(
        (b) => income + gain > b.min && income + gain <= b.max
      );
      marginalRate =
        ((m ? m.rate : brackets[brackets.length - 1].rate) || 0) * 100;
    }

    const taxRounded = Math.round(tax * 100) / 100;
    const net = Math.round((proceeds - taxRounded) * 100) / 100;

    const results_json = {
      capitalGain: gain,
      taxOwned: taxRounded,
      effectiveRate,
      marginalRate,
      netProceeds: net,
    };

    return { inputs_json, results_json, pdf_notes };
  };

  const calculateCapitalGains = () => {
    const computed = computeResults();
    if (!computed) return false;

    setResults(computed.results_json);
    latestPayloadRef.current = computed;

    return true;
  };

  const sendResultsToEmail = async (emailToSend) => {
    const payload = latestPayloadRef.current;
    if (!payload?.inputs_json || !payload?.results_json) return null;

    setSendingResults(true);

    try {
      const resp = await axios.post(
        PROXY_URL,
        {
          path: "/public/send-results",
          method: "POST",
          raw: true,
          qa_mode: qa,
          data: {
            action: "send_results_email",
            email: emailToSend,
            calculator_name: calculatorName,
            calculator_year: String(year),
            page_url: pageUrl,
            timestamp_utc: new Date().toISOString(),
            results_json: payload.results_json,
            inputs_json: payload.inputs_json,
            pdf_notes: payload.pdf_notes,
            schema_version: 1,
          },
        },
        {
          headers: { "Content-Type": "application/json" },
          timeout: 30000,
        }
      );

      if (resp?.data?.success === false) {
        throw new Error(resp?.data?.message || "Failed to send results email");
      }

      setShowConfirmModal(false);
      setShowUpdateEmailModal(false);
      scrollToResults();

      return resp.data;
    } catch (err) {
      console.error("sendResultsToEmail error:", err);
      return null;
    } finally {
      setSendingResults(false);
    }
  };

  const handleConfirmSend = async () => {
    if (!storedEmail) {
      setShowConfirmModal(false);
      setShowUpdateEmailModal(true);
      return;
    }
    await sendResultsToEmail(storedEmail);
  };

  const handleChangeEmail = () => {
    setShowConfirmModal(false);
    setShowUpdateEmailModal(true);
  };

  const handleUpdateEmailAndSend = async (newEmail) => {
    writeUnlock({ email: newEmail });
    setStoredEmail(newEmail);
    await sendResultsToEmail(newEmail);
  };

  return (
    <>
      <div className="container py-5 capital-gains-calculator">
        <div className="row gap-3">
          <div className="col-md-6 bg-white shadow p-3 rounded-4">
            <div className="d-flex justify-content-between align-items-center mb-2">
              <h5 className="mb-0">Capital Gains Tax Calculator</h5>
              <span className="badge bg-primary-subtle text-primary">
                Tax Year {year}
              </span>
            </div>

            <div className="mb-3">
              <label className="form-label">Filing Status</label>
              <select
                className="form-select"
                value={filingStatus}
                onChange={(e) => setFilingStatus(e.target.value)}
              >
                <option value="">Select Status</option>

                {/* ✅ values are stable keys; labels are spaced words */}
                <option value="single">Single</option>
                <option value="marriedJoint">Married Filing Jointly</option>
                <option value="marriedSeparate">Married Filing Separately</option>
                <option value="headOfHousehold">Head of Household</option>
              </select>
            </div>

            <div className="mb-3">
              <label className="form-label">{config.incomeLabel}</label>
              <input
                type="number"
                className="form-control"
                value={taxableIncome}
                onChange={(e) => setTaxableIncome(e.target.value)}
                placeholder={config.incomeLabel}
              />
            </div>

            <div className="mb-3">
              <label className="form-label d-block">Holding Period</label>
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  name="holdingPeriod"
                  id="shortTerm"
                  value="short-term"
                  checked={holdingPeriod === "short-term"}
                  onChange={() => setHoldingPeriod("short-term")}
                />
                <label className="form-check-label" htmlFor="shortTerm">
                  One year or less (Short-term)
                </label>
              </div>
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  name="holdingPeriod"
                  id="longTerm"
                  value="long-term"
                  checked={holdingPeriod === "long-term"}
                  onChange={() => setHoldingPeriod("long-term")}
                />
                <label className="form-check-label" htmlFor="longTerm">
                  More than one year (Long-term)
                </label>
              </div>
            </div>

            <div className="mb-3">
              <label className="form-label">Cost Basis</label>
              <input
                type="number"
                className="form-control"
                value={costBasis}
                onChange={(e) => setCostBasis(e.target.value)}
                placeholder="Cost Basis"
              />
            </div>

            <div className="mb-4">
              <label className="form-label">Sale Proceeds</label>
              <input
                type="number"
                className="form-control"
                value={saleProceeds}
                onChange={(e) => setSaleProceeds(e.target.value)}
                placeholder="Sale Proceeds"
              />
            </div>

            <button
              className="btn w-100"
              onClick={() => {
                const ok = calculateCapitalGains();
                if (!ok) return;
                openGateFlow();
              }}
              style={{
                background: "#0f8a4c",
                borderColor: "#0f8a4c",
                color: "white",
              }}
            >
              View Results
            </button>

            <div className="mt-3">
              <small className="text-muted">
                Click <strong>View Results</strong> to unlock your calculation.
              </small>
            </div>
          </div>

          <div className="col-md-4 bg-white shadow p-3 rounded-4" ref={resultsRef}>
            <div className="bg-success text-white p-2 rounded" style={{ background: "#0f8a4c" }}>
              Tax Calculation Results
            </div>

            <div
              className="unk-results-wrap mt-2"
              style={{
                background: !unlocked
                  ? "linear-gradient(180deg, rgba(255,255,255,0.92), rgba(255,255,255,0.92))"
                  : "transparent",
              }}
            >
              {!unlocked && <div className="unk-bg-blur" />}

              <div style={{ position: "relative", zIndex: 1, width: "100%" }}>
                <div className={!unlocked ? "unk-results-blur" : ""}>
                  {results ? (
                    <div className="p-4 bg-white rounded shadow-sm border">
                      <div className="d-flex justify-content-between">
                        <span className="fw-semibold text-dark">Capital Gain/Loss:</span>
                        <span
                          className={
                            results.capitalGain >= 0
                              ? "fw-bold text-success"
                              : "fw-bold text-danger"
                          }
                        >
                          {fmtMoney(results.capitalGain)}
                        </span>
                      </div>

                      <div className="d-flex justify-content-between">
                        <span className="fw-semibold text-dark">Tax Owed:</span>
                        <span className="fw-bold text-danger">
                          {fmtMoney(results.taxOwned)}
                        </span>
                      </div>

                      <div className="d-flex justify-content-between">
                        <span className="fw-semibold">Effective Tax Rate:</span>
                        <span>{Number(results.effectiveRate || 0).toFixed(1)}%</span>
                      </div>

                      <div className="d-flex justify-content-between">
                        <span className="fw-semibold">Marginal Tax Rate:</span>
                        <span>{Number(results.marginalRate || 0).toFixed(1)}%</span>
                      </div>

                      <div className="d-flex justify-content-between">
                        <span className="fw-semibold text-dark">
                          Net Proceeds After Tax:
                        </span>
                        <span className="fw-bold text-primary">
                          {fmtMoney(results.netProceeds)}
                        </span>
                      </div>

                      <div className="text-muted small mt-3 border-top pt-2">
                        Tax Treatment:{" "}
                        {holdingPeriod === "short-term"
                          ? "Short-Term Capital Gains"
                          : "Long-Term Capital Gains"}
                      </div>
                    </div>
                  ) : (
                    <div className="text-muted">
                      Enter values and click View Results to see your estimate.
                    </div>
                  )}
                </div>

                {!unlocked && (
                  <div
                    className="unk-results-overlay"
                    onClick={() => {
                      if (!results) {
                        const ok = calculateCapitalGains();
                        if (!ok) return;
                      }
                      openGateFlow();
                    }}
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        if (!results) {
                          const ok = calculateCapitalGains();
                          if (!ok) return;
                        }
                        openGateFlow();
                      }
                    }}
                    aria-label="Results locked. Open unlock modal."
                  >
                    <div className="unk-overlay-card">
                      <div className="unk-overlay-title">Results Locked</div>
                      <div className="unk-overlay-body">
                        Enter your name and email to view your results instantly.
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="text-center text-muted small mt-4 w-50 mx-auto">
          <p>{yearCfg.disclaimer}</p>
        </div>
      </div>

      <LeadGateModal
        open={showLeadModal}
        onClose={() => setShowLeadModal(false)}
        onSuccess={(payload) => handleLeadSuccess(payload)}
        calculatorName={calculatorName}
        calculatorYear={String(year)}
        pageUrl={pageUrl}
        endpoint={endpoint}
        resultsJson={latestPayloadRef.current?.results_json || results}
        disclaimer={yearCfg.disclaimer}
        inputsJson={
          latestPayloadRef.current?.inputs_json || {
            filingStatus,
            taxableIncome,
            holdingPeriod,
            costBasis,
            saleProceeds,
            calculator_year: String(year),
          }
        }
        pdf_notes={latestPayloadRef.current?.pdf_notes}
      />

      <SuccessModal
        open={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        onViewResults={handleSuccessViewResults}
      />

      <ConfirmSendResultsModal
        open={showConfirmModal}
        email={storedEmail}
        onClose={() => setShowConfirmModal(false)}
        onViewResults={() => {
          setShowConfirmModal(false);
          scrollToResults();
        }}
        onSend={handleConfirmSend}
        onChangeEmail={handleChangeEmail}
        sending={sendingResults}
      />

      <UpdateEmailModal
        open={showUpdateEmailModal}
        initialEmail={storedEmail}
        onClose={() => setShowUpdateEmailModal(false)}
        onSend={handleUpdateEmailAndSend}
        sending={sendingResults}
        storedEmail={storedEmail}
        endpoint={PROXY_URL}
        resultsJson={latestPayloadRef.current?.results_json || results}
        inputsJson={latestPayloadRef.current?.inputs_json}
        calculatorName={calculatorName}
        calculatorYear={String(year)}
        pageUrl={pageUrl}
        disclaimer={yearCfg.disclaimer}
        pdf_notes={latestPayloadRef.current?.pdf_notes}
      />
    </>
  );
}

export default CapitalGainsTaxCalculator;
